// 이미지 등록 규격.
//
// 업로드 화면의 안내 문구와 "이미지 제작 가이드" 페이지가 모두 이 파일을 참조한다.
// 값을 고칠 때 여기만 고치면 세 곳이 함께 바뀐다.
//
// ── 값의 출처 ─────────────────────────────────────────────────────
// displayWidth / displayHeight
//   Figma 실측값이다. 파일 xsS20cl9Iwm2XO7WPQkg54 의 각 노드 크기를 그대로 옮겼다.
//   화면이 바뀌면 이 값도 같이 갱신해야 한다.
// formats
//   기존 업로드 input 의 accept 속성에 있던 값 그대로다.
// maxUploadMb
//   서버 설정값이다. application.yml 의 multipart.max-file-size 는 100MB 지만
//   실제로 막는 곳은 AttachmentService.MAX_FILE_SIZE_BYTES = 10MB 다.
//   100MB 로 안내하면 10MB 넘는 파일이 다 올라간 뒤에야 거절당한다.
//
// safeArea (메인 배너)
//   퍼블리싱 화면에서 제목·부제 글상자가 놓이는 실제 좌표다.
//   미디어 허브 307:5269, 자사몰 307:7240 — 둘 다 좌측 366px 에서 시작한다.
//
// uploadWidth / uploadHeight (선택)
//   화면 크기와 권장 업로드 크기가 다를 때 쓴다. 상품 사진이 그렇다 —
//   목록 카드는 220, 상품 상세는 480 으로 두 곳에서 다르게 쓰이므로
//   가장 큰 쪽(480)의 2배로 잡는다.
// formats (선택)
//   이 규격에서만 권장 형식이 다를 때 쓴다.
//
// ── 아직 확정되지 않은 값 ─────────────────────────────────────────
// recommendedMb, retina 는 운영 기준이 정해지지 않아 초안으로 넣어 둔 것이다.
// 담당자 확인 후 확정할 것.

export const UPLOAD_FORMATS = ['JPG', 'PNG', 'GIF', 'WEBP']
export const UPLOAD_ACCEPT = 'image/jpeg,image/png,image/gif,image/webp,.jpg,.jpeg,.png,.gif,.webp'
export const MAX_UPLOAD_MB = 10 // 서버 한도 (AttachmentService)

export const IMAGE_SPECS = {
  MEDIAHUB_MAIN_BANNER: {
    service: '미디어 허브',
    label: '메인 배너',
    where: '미디어 허브 > 메인배너 관리',
    figmaNode: '307:5183',
    displayWidth: 1920,
    displayHeight: 490,
    recommendedMb: 2, // 초안
    retina: true, // 초안 — 2배수(3840 × 980) 제작 권장
    safeArea: '왼쪽 366~1030px 에 제목·부제가 흰 글씨로 얹힙니다. 그 자리는 어둡게 비워 두세요.',
    note: '배너 제목·부제는 등록 화면의 입력칸에서 화면에 얹습니다. 그림에 같은 문구를 넣으면 두 번 나옵니다. 자사몰 메인 배너와 비율이 달라 같은 이미지를 양쪽에 쓰면 잘립니다.',
  },
  MALL_MAIN_BANNER: {
    service: '자사몰',
    label: '메인 배너',
    where: '메인노출 관리 > 메인 배너',
    figmaNode: '307:7236',
    displayWidth: 1920,
    displayHeight: 370,
    recommendedMb: 2, // 초안
    retina: true, // 초안 — 2배수(3840 × 740) 제작 권장
    safeArea: '왼쪽 366~1030px 에 제목·부제가 흰 글씨로 얹힙니다. 그 자리는 어둡게 비워 두세요.',
    note: '제목·부제는 등록 화면의 입력칸에서 화면에 얹습니다. 그림에 같은 문구를 넣으면 두 번 나옵니다. 미디어 허브 메인 배너와 비율이 달라 같은 이미지를 양쪽에 쓰면 잘립니다.',
  },
  MALL_MAIN_PRODUCT: {
    service: '자사몰',
    label: '메인 상품 이미지',
    where: '메인노출 관리 > 메인 상품',
    figmaNode: '307:7249',
    displayWidth: 129,
    displayHeight: 250,
    recommendedMb: 1, // 초안
    retina: true, // 초안
    safeArea: '카드(282 × 340) 안에 놓입니다. 배경이 비치는 PNG 를 권장합니다.', // 초안
    note: '세로로 긴 비율입니다. 가로형 사진을 넣으면 좌우가 잘립니다.',
  },
  PRODUCT_LIST: {
    service: '자사몰',
    label: '상품 목록 이미지',
    where: '상품 관리 > 상품 등록·수정 > 목록 이미지',
    figmaNode: '8003:2816',
    // 목록 카드에서는 220, 상품 상세에서는 480 으로 쓴다. 큰 쪽을 적는다.
    displayWidth: 480,
    displayHeight: 480,
    uploadWidth: 1000,
    uploadHeight: 1000,
    recommendedMb: 1,
    retina: false, // uploadWidth 가 이미 2배 기준이다
    // 자동 보정을 지원하지 않는 WEBP 는 권장 목록에서 뺀다.
    formats: ['PNG', 'JPG'],
    safeArea:
      '상품이 긴 변 기준으로 화면의 86% 를 채우도록 가운데에 두세요. ' +
      '배경은 투명(PNG) 또는 흰색으로 두고 그림자·소품은 넣지 마세요.',
    note:
      '규격과 달라도 올리면 서버가 여백을 다듬어 1000 × 1000 정사각으로 맞춥니다. ' +
      '다만 원본이 작으면 늘어나면서 흐려지고, WEBP 는 자동 보정이 되지 않아 올린 그대로 저장됩니다. ' +
      '카드에 여러 상품이 나란히 서기 때문에 사진마다 여백이 다르면 상품 크기가 제각각으로 보입니다.',
  },
  PRODUCT_DETAIL: {
    service: '자사몰',
    label: '상품 상세 이미지',
    where: '상품 관리 > 상품 등록·수정 > 상세 이미지',
    figmaNode: '',
    // 상품 상세 본문 칸 폭이다. 세로는 내용에 따라 길어진다.
    displayWidth: 1140,
    displayHeight: 0,
    recommendedMb: 2,
    retina: false,
    safeArea: '',
    note:
      '세로로 긴 본문 그림이라 자동 보정을 하지 않습니다. 올린 그대로 나갑니다. ' +
      '가로 1140px 에 맞춰 만들고, 그보다 좁으면 늘어나 흐려집니다.',
  },
  MEDIAHUB_CONTENT_THUMBNAIL: {
    service: '미디어 허브',
    label: '콘텐츠 썸네일',
    where: '미디어 허브 > 수집 콘텐츠 관리 (수동 등록 시)',
    figmaNode: '252:2551',
    displayWidth: 282,
    displayHeight: 158,
    recommendedMb: 1, // 초안
    retina: true, // 초안
    safeArea: '',
    note: '16:9 입니다. 유튜브·네이버TV 썸네일이 그대로 맞습니다. 비어 있으면 기본 이미지(REAL GOLD 워드마크)가 나갑니다.',
  },
  MEDIAHUB_FEATURE_CARD: {
    service: '미디어 허브',
    label: '큰 카드 이미지',
    where: '미디어 허브 > 홈페이지 노출 콘텐츠 관리 (상단 강조)',
    figmaNode: '252:2497',
    displayWidth: 584,
    displayHeight: 400,
    recommendedMb: 1, // 초안
    retina: true, // 초안
    safeArea: '',
    note: '썸네일(16:9)과 비율이 다릅니다. 강조 카드는 따로 준비해야 합니다.',
  },
}

// 비율을 "3.92 : 1" 형태로
export const ratioText = (spec) => `${(spec.displayWidth / spec.displayHeight).toFixed(2)} : 1`

// 2배수 크기
export const retinaText = (spec) =>
  spec.retina ? `${spec.displayWidth * 2} × ${spec.displayHeight * 2}` : ''

// 업로드 화면에 한 줄로 붙일 요약
export const summaryText = (key) => {
  const spec = IMAGE_SPECS[key]
  if (!spec) return ''
  // 권장 업로드 크기가 따로 있으면 그것을 쓴다(상품 사진).
  const w = spec.uploadWidth || spec.displayWidth
  const h = spec.uploadHeight || spec.displayHeight
  const parts = [
    h ? `권장 ${w} × ${h} px (${ratioText(spec)})` : `권장 가로 ${w} px (세로 자유)`,
    (spec.formats || UPLOAD_FORMATS).join(' · '),
  ]
  if (spec.recommendedMb) parts.push(`${spec.recommendedMb}MB 이하 권장`)
  return parts.join('  |  ')
}
